<script>
  import { createEventDispatcher } from 'svelte'
  import { faTimes } from '@fortawesome/pro-regular-svg-icons'

  import filterClasses, { cssPrefix } from '../helper-classes.js'
  import Icon from '../Icon/'

  export let id = null
  export let status = ''
  export let closable = false
  export let centered = false
  export let iconBefore = null

  export let style = null
  export let helperClass = null
  let importedClasses = ''
  export { importedClasses as class }
  export let classPermissiveMode = false
  if (helperClass) {
    console.debug("[DS:deprecation] please replace 'helperClass' prop by 'class'")
    if (!importedClasses) {
      importedClasses = helperClass
    }
  }
  const classes = [`${cssPrefix}callout`]
  if (importedClasses) classes.push(...filterClasses(importedClasses, classPermissiveMode))

  const dispatch = createEventDispatcher()
  if (centered) classes.push('is-centered')

  // should we have more orthogonality with button ?
  if (!['', 'primary', 'success', 'info', 'warning', 'error'].includes(status)) {
    console.debug(`[DS:Callout] invalid status ${status}`)
  } else if (status) {
    classes.push('is-status-' + status)
  }
</script>

<div class={classes.join(' ')} {style} {id} role="status">
  {#if iconBefore}
    <aside class={`${cssPrefix}callout-icon`}>
      {#if typeof iconBefore === 'string'}
        <Icon name={iconBefore} />
      {:else}
        <Icon icon={iconBefore} />
      {/if}
    </aside>
  {/if}

  <div class={`${cssPrefix}callout-body`}>
    <slot />
  </div>

  {#if closable}
    <div class={`${cssPrefix}callout-close`}>
      <button on:click|preventDefault={() => dispatch('close')} class={`${cssPrefix}icon is-delete`}>
        <Icon icon={faTimes} />
      </button>
    </div>
  {/if}
</div>
